import React from "react";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FaTimes } from "react-icons/fa";

import Filter from "../../filter/FilterPannel";
import FieldController from "../../../controller/FieldController";

class ConditionSelect extends React.Component {
  onConditionChanged = (condition) => {
    let filter = { ...this.props.filter };
    const options = FieldController.getOptions(
      this.props.fields[filter.field.value]
    );
    filter = { ...filter, condition, options, andor: false };
    this.props.onFilterChanged(this.props.index, filter);
  };

  onValueChanged = (select) => {
    const filter = {
      ...this.props.filter,
      select,
      value: select ? `~${select.map((val) => val.value).join("~")}~` : "",
    };
    this.props.onFilterChanged(this.props.index, filter);
  };

  render() {
    const i = this.props.index;
    const filter = this.props.filter;

    if (
      (!filter.options || filter.options.length === 0) &&
      this.props.fields[filter.field.value]
    ) {
      const options = FieldController.getOptions(
        this.props.fields[filter.field.value]
      );
      const valueIds = (filter.value || "").split("~").filter((v) => v);

      const select = options.filter((opt) =>
        valueIds.includes(String(opt.value))
      );

      filter.options = options;
      filter.select = select;
    }

    return (
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        {filter.field.label}

        <div className="condition-select col-md-3">
          <Select
            value={filter.condition}
            onChange={(selected) => this.onConditionChanged(selected)}
            options={filter.conditions}
            isSearchable={true}
            isClearable={true}
          />
        </div>

        <div className="condition-select col-md-8 value-float">
          {filter.condition &&
          filter.condition.value !== Filter.Empty &&
          filter.condition.value !== Filter.NotEmpty ? (
            <Select
              value={filter.select}
              options={filter.options}
              onChange={(selected) => this.onValueChanged(selected)}
              isSearchable={true}
              isClearable={true}
              isMulti={true}
              className="col-md-8"
            />
          ) : null}

          {false &&
          (filter.isSelect ||
            filter.isCity ||
            filter.isState ||
            filter.isCountry) &&
          filter.select &&
          filter.select.length > 1 ? (
            <div>
              <label>Inner Condition</label>
              <Form.Check type="radio">
                <Form.Check.Input
                  type="radio"
                  checked={filter.andor}
                  onChange={() => this.onCondition(i, true)}
                />
                <Form.Check.Label>AND</Form.Check.Label>
              </Form.Check>
              <Form.Check type="radio">
                <Form.Check.Input
                  type="radio"
                  checked={!filter.andor}
                  onChange={() => this.onCondition(i, false)}
                />
                <Form.Check.Label>OR</Form.Check.Label>
              </Form.Check>
            </div>
          ) : null}

          <Button variant="danger" onClick={() => this.props.onDelete(i)}>
            <FaTimes />
          </Button>
        </div>
      </div>
    );
  }
}
export default ConditionSelect;
